// Hiệu ứng xuất hiện khi cuộn cho các khối có thuộc tính data-aos (chỉ một kiểu: hiện dần + nhích lên).
// Trạng thái ẩn/hiện và transition nằm trong App.css; ở đây chỉ gắn class aos-animate khi khối lọt vào
// màn hình, mỗi khối một lần.
//
// Trước đây dùng thư viện AOS: nó đo lại vị trí mọi khối (getBoundingClientRect) khi cuộn, khi DOM đổi và
// khi trang đổi chiều cao, gây reflow cưỡng bức và chiếm luồng chính lúc tải trang (PageSpeed: TBT,
// "forced reflow"). IntersectionObserver để trình duyệt tự theo dõi, không tốn layout trên luồng chính.
//
// Quy tắc để không chồng nhiều lớp chuyển động:
// - Khối đã nằm trong màn hình lúc trang vừa vào thì hiện ngay (aos-instant): hiệu ứng chuyển trang đã lo.
// - Nhiều khối lọt vào màn hình cùng một lượt thì tự lệch nhau STAGGER_MS, không viết tay data-aos-delay.
const SELECTOR = '[data-aos]:not(.aos-animate)';
// Khoảng thời gian sau khi trang vào mà khối lọt màn hình vẫn coi là "có sẵn từ đầu"
const PAGE_ENTER_WINDOW_MS = 450;
const STAGGER_MS = 60;
const STAGGER_MAX_MS = 180;

let initialized = false;
let pageEnterAt = 0;

const now = () => (typeof performance !== 'undefined' ? performance.now() : Date.now());

// Gọi khi route mới mount và khi màn hình tải bắt đầu mờ (trang bên dưới vừa hiện ra)
export const markPageEnter = () => {
  pageEnterAt = now();
};

const showAll = () => {
  document.querySelectorAll(SELECTOR).forEach((el) => el.classList.add('aos-animate', 'aos-instant'));
};

export const initAOS = () => {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;
  markPageEnter();

  if (typeof IntersectionObserver === 'undefined' || typeof MutationObserver === 'undefined') {
    showAll();
    return;
  }

  const intersectionObserver = new IntersectionObserver((entries) => {
    const instant = now() - pageEnterAt < PAGE_ENTER_WINDOW_MS;
    let index = 0;
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      intersectionObserver.unobserve(el);
      if (instant) {
        el.classList.add('aos-animate', 'aos-instant');
        return;
      }
      el.style.transitionDelay = `${Math.min(index * STAGGER_MS, STAGGER_MAX_MS)}ms`;
      index += 1;
      el.classList.add('aos-animate');
    });
  }, {
    // Khối nhô vào màn hình 24px mới bắt đầu hiện
    rootMargin: '0px 0px -24px 0px',
  });

  // Theo dõi cả khối mới thêm và khối React dùng lại thẻ cũ rồi gắn thêm data-aos.
  // observe() một phần tử đã theo dõi thì không có tác dụng gì, nên quét lại cả trang là an toàn.
  let frame = 0;
  const observeAll = () => {
    frame = 0;
    document.querySelectorAll(SELECTOR).forEach((el) => intersectionObserver.observe(el));
  };
  observeAll();

  new MutationObserver(() => {
    if (!frame) frame = requestAnimationFrame(observeAll);
  }).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['data-aos'],
  });
};
